import { useContext, useEffect, useState } from 'react';
import ArrowLeft from '../../Assets/Arrow left.svg';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import ProductDetails from './Components/ProductDetails.Form.js'
import { InventoryEditProductFormContext } from '../../Context/InventoryEditProductFormContext.js';
import PricesAndTaxes from './Components/PricesAndTaxes.Form.js';
import { showToast } from '../../Components/Toaster/Toaster';
import { v4 as uuidv4 } from 'uuid';
import CrossSmall from '../../Assets/CrossSmall.svg';
import AddProductImage from './Components/AddProductImage.js';
import Modal from './Components/Modal/Modal.js';
import Specification from './Components/Specification.Form.js';
import PackagingDetails from './Components/PackagingDetails.Form.js';
import { camelCaseToReadable, getMediaUrl, toCamelCase } from '../../lib/utils/utils.js';
import { specificationsArray } from '../../Routes/InventoryManagement/Specifications.js';
import Tags from './Components/Tags.js';
import ProductOrganisation from './Components/ProductOrganisation.Form.js';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInventoryProduct, fetchInventoryProducts } from '../../Features/inventoryManagementSlice.js';
import { cachedDataPublish, getCategoriesForStore, getCollectionForCategory, getCustomCollectionsForStore, getSizeChartById, updateProduct } from '../../lib/utils/apiCalls.js';
import LoadingTransparent from '../../Components/Loading/LoadingTransparent.js';
import imageCompression from 'browser-image-compression';
import SizeChart from './Components/SizeChart.js';
import SelectCategory from './Components/SelectCategory.js';

const gstCodes = [
    { id: 'GST_3', codeName: 'GST_3' },
    { id: 'GST_5', codeName: 'GST_5' },
    { id: 'GST_12', codeName: 'GST_12' },
    { id: 'GST_18', codeName: 'GST_18' },
    { id: 'GST_28', codeName: 'GST_28' },
    { id: 'GST_APPRAEL', codeName: 'GST_Apparel' }
];

function InventoryEditProduct() {
    const params = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const activeProduct = useSelector((state) => state.inventoryManagement.activeProduct.activeProduct);

    const [selectedCategory1, setSelectedCategory1] = useState('');
    const [selectedCategory2, setSelectedCategory2] = useState('');

    const {
        keywords,
        setKeywords,
        productDetails,
        setProductDetails,
        specifications,
        setSpecifications,
        setProductSpecifications,
        additionalSpecifications,
        setAdditionalSpecifications,
        pricesAndTaxes,
        setPricesAndTaxes,
        packagingDetails,
        setPackagingDetails,
        inventoryInputs,
        setInventoryInputs,
        selectedCollections,
        selectedCustomCollections,
        selectedTags,
        setSelectedTags,
        productImages,
        setProductImages,
        formErrors,
        setFormErrors,
        defaultFormErrors,
        loading,
        setLoading,
        productSpecifications,
        selectedChart,
        setSelectedChart,

        selectedCategory,
        setSelectedCategory,
        selectedProductType,
        setSelectedProductType,
    } = useContext(InventoryEditProductFormContext);

    const [keywordValue, setKeywordValue] = useState('');

    const handleChange = (e) => {
        setKeywordValue(e.target.value);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (keywords.some(obj => obj.keyword === keywordValue)) {
                showToast('Keyword already present!', 'warning');
            } else {
                if (keywordValue) {
                    setKeywords(prev => [...prev, { keyword: keywordValue, id: uuidv4() }]);
                    setKeywordValue('');
                }
            }
        }
    };

    const removeKeyword = (id) => {
        const filteredList = keywords.filter(keyword => keyword.id !== id);
        setKeywords(filteredList);
    };

    async function handleSaveDraft() {
        const validationErrors = {};

        if (!productDetails.productName.trim()) {
            validationErrors.productName = 'Product name is required';
        }
        if (!pricesAndTaxes.mrp) {
            validationErrors.mrp = 'Required field';
        }
        if (!pricesAndTaxes.sellingPrice) {
            validationErrors.sellingPrice = 'Required field';
        }
        if (!pricesAndTaxes.taxCode || Object.keys(pricesAndTaxes.taxCode || {}).length === 0) {
            validationErrors.taxCode = 'Required field';
        }

        if (Object.keys(validationErrors).length === 0) {
            setLoading(true);
            setFormErrors(defaultFormErrors);

            let additionals;
            if (additionalSpecifications.length > 0) {
                additionals = additionalSpecifications.reduce((acc, spec) => {
                    const key = spec.id;
                    acc[key] = spec.value;
                    return acc;
                }, {});
            }

            let productSpecsList;
            if (productSpecifications.length > 0) {
                productSpecsList = productSpecifications.reduce((acc, spec) => {
                    const key = spec.id;
                    acc[key] = spec.value;
                    return acc;
                }, {});
            }

            let finalSpecs = {
                ...specifications,
                ...productSpecsList,
                ...additionals
            };

            const productImagesList = [];
            if (productImages.length > 0) {
                for (const image of productImages) {
                    let url;

                    if (image.file) {
                        url = await getMediaUrl(image.file);

                        if (image.file.size > 1048576) {
                            try {
                                let compressedBlob = await imageCompression(image.file, {
                                    maxSizeMB: 1,
                                    maxWidthOrHeight: 1920,
                                    useWebWorker: true
                                });

                                let compressedFile = new File([compressedBlob], image.file.name, { type: image.file.type, lastModified: Date.now() });

                                if (compressedFile) {
                                    url = await getMediaUrl(compressedFile);
                                } else {
                                    url = await getMediaUrl(image.file);
                                }
                            } catch (err) {
                                url = await getMediaUrl(image.file);
                            }
                        } else {
                            url = await getMediaUrl(image.file);
                        }
                    } else {
                        url = image.url;
                    }

                    productImagesList.push(url);
                }
            }

            let callData = {
                productName: productDetails.productName,
                productMRP: pricesAndTaxes.mrp,
                productSellingPrice: pricesAndTaxes.sellingPrice,
                productTaxCode: pricesAndTaxes.taxCode.id,
                status: 'Draft',
                productCategory: selectedCategory,
                productType: selectedProductType,
                productDesc: productDetails.productDescription,
                productImgUrls: productImagesList,
                productHSNCode: pricesAndTaxes.hsnCode,
                country: pricesAndTaxes.country,
                productSpecs: finalSpecs,
                keywords: keywords.map(item => item.keyword),
                Tag: selectedTags,
                ...packagingDetails,
                isVisible: activeProduct.product.isVisible,
                productStock: inventoryInputs.stock ? inventoryInputs.stock : null,
                productSKU: inventoryInputs.skuCode
            };

            const categories = await getCategoriesForStore();

            const collectionResponses = await Promise.all(
                categories.category.map(category => getCollectionForCategory(category.id))
            );

            const collections = collectionResponses.flatMap(item => item.collection || []);
            const customCollections = await getCustomCollectionsForStore();

            const allCollectionIds = collections.map(collection => collection.id);
            const allCustomCollectionIds = customCollections.collection.map(collection => collection.id);

            const selectedCollectionIds = selectedCollections.map(collection => collection.id);
            const selectedCustomCollectionIds = selectedCustomCollections.map(collection => collection.id);

            const removeCollectionId = allCollectionIds.filter(id => !selectedCollectionIds.includes(id));
            const removeCustomCollectionId = allCustomCollectionIds.filter(id => !selectedCustomCollectionIds.includes(id));

            const finalCollectionIds = selectedCollectionIds.filter(
                id => !removeCollectionId.includes(id)
            );

            const finalCustomCollectionIds = selectedCustomCollectionIds.filter(
                id => !removeCustomCollectionId.includes(id)
            );

            callData = {
                ...callData,
                removeCollectionId: [...new Set(removeCollectionId)],
                removeCustomCollectionId: [...new Set(removeCustomCollectionId)],
                collectionIds: [...new Set(finalCollectionIds)],
                customCollectionId: [...new Set(finalCustomCollectionIds)]
            };

            try {
                const response = await updateProduct(callData, params.productId);

                if (response?.status === 200) {
                    await cachedDataPublish([`/v1/product/${params.productId}`]);
                    setLoading(false);
                    showToast('Draft Updated!', 'success');
                    dispatch(fetchInventoryProducts());
                    navigate(`${location.pathname.split('/').slice(0, -1).join('/')}`);
                } else {
                    setLoading(false);
                    showToast('Error updating draft!', 'error');
                }
            } catch (err) {
                setLoading(false);
                showToast('Error updating draft!', 'error');
            }
        } else {
            setFormErrors(validationErrors);
            return;
        }
    }

    async function handleUpdateClick() {
        const validationErrors = {};

        if (!productDetails.productName.trim()) {
            validationErrors.productName = 'Product name is required';
        }
        if (!pricesAndTaxes.mrp) {
            validationErrors.mrp = 'Required field';
        }
        if (!pricesAndTaxes.sellingPrice) {
            validationErrors.sellingPrice = 'Required field';
        }
        if (!pricesAndTaxes.taxCode || Object.keys(pricesAndTaxes.taxCode || {}).length === 0) {
            validationErrors.taxCode = 'Required field';
        }
        if (!pricesAndTaxes.hsnCode) {
            validationErrors.hsnCode = 'Required field';
        }
        if (!specifications.size.trim()) {
            validationErrors.size = 'Required field';
        }
        if (packagingDetails.width === '' || packagingDetails.width == null) {
            validationErrors.width = 'Required field';
        } else if (Number(packagingDetails.width) <= 0) {
            validationErrors.width = 'Must be greater than 0';
        }
        if (packagingDetails.height === '' || packagingDetails.height == null) {
            validationErrors.height = 'Required field';
        } else if (Number(packagingDetails.height) <= 0) {
            validationErrors.height = 'Must be greater than 0';
        }
        if (packagingDetails.weight === '' || packagingDetails.weight == null) {
            validationErrors.weight = 'Required field';
        } else if (Number(packagingDetails.weight) <= 0) {
            validationErrors.weight = 'Must be greater than 0';
        }
        if (keywords.length === 0) {
            validationErrors.keywords = 'Please enter keywords';
        }
        if (productImages.length === 0) {
            validationErrors.images = 'Product image is required';
        }
        if(selectedCategory1 !== 'Beauty & Personal Care') {
            if(!specifications.color.trim()) {
                validationErrors.color = 'Required field';
            }
        }

        if (Object.keys(validationErrors).length === 0) {
            setLoading(true);
            setFormErrors(defaultFormErrors);

            const additionals = additionalSpecifications.reduce((acc, spec) => {
                const key = spec.id;
                acc[key] = spec.value;
                return acc;
            }, {});

            const productSpecsList = productSpecifications.reduce((acc, spec) => {
                const key = spec.id;
                acc[key] = spec.value;
                return acc;
            }, {});

            let finalSpecs = {
                ...specifications,
                ...productSpecsList,
                ...additionals
            };

            const productImagesList = [];
            for (const image of productImages) {
                let url;

                if (image.file) {
                    url = await getMediaUrl(image.file);

                    if (image.file.size > 1048576) {
                        try {
                            let compressedBlob = await imageCompression(image.file, {
                                maxSizeMB: 1,
                                maxWidthOrHeight: 1920,
                                useWebWorker: true
                            });

                            let compressedFile = new File([compressedBlob], image.file.name, { type: image.file.type, lastModified: Date.now() });

                            if (compressedFile) {
                                url = await getMediaUrl(compressedFile);
                            } else {
                                url = await getMediaUrl(image.file);
                            }
                        } catch (err) {
                            url = await getMediaUrl(image.file);
                        }
                    } else {
                        url = await getMediaUrl(image.file);
                    }
                } else {
                    url = image.url;
                }

                productImagesList.push(url);
            }

            let callData = {
                productName: productDetails.productName,
                productMRP: pricesAndTaxes.mrp,
                productSellingPrice: pricesAndTaxes.sellingPrice,
                productTaxCode: pricesAndTaxes.taxCode.id,
                productDesc: productDetails.productDescription,
                productImgUrls: productImagesList,
                productHSNCode: pricesAndTaxes.hsnCode,
                country: pricesAndTaxes.country,
                productSpecs: finalSpecs,
                productCategory: selectedCategory,
                productType: selectedProductType,
                keywords: keywords.map(item => item.keyword),
                Tag: selectedTags,
                ...packagingDetails,
                productStock: inventoryInputs.stock,
                productSKU: inventoryInputs.skuCode
            };

            if (activeProduct.product.status === 'Draft') {
                callData.status = 'Active';
                callData.isVisible = true;
            } else {
                callData.status = activeProduct.product.status;
                callData.isVisible = activeProduct.product.isVisible;
            }

            if (selectedChart && Object.keys(selectedChart).length > 0) {
                callData.SizeChartId = selectedChart.id;
            }

            const categories = await getCategoriesForStore();

            const collectionResponses = await Promise.all(
                categories.category.map(category => getCollectionForCategory(category.id))
            );

            const collections = collectionResponses.flatMap(item => item.collection || []);
            const customCollections = await getCustomCollectionsForStore();

            const { collectionName, customCollectionName } = activeProduct;

            const previousCollectionIds = collections
                .filter(c => collectionName.includes(c.CollectionName))
                .map(item => item.id);

            const previousCustomCollectionIds = customCollections.collection
                .filter(c => customCollectionName.includes(c.CollectionName))
                .map(item => item.id);

            const selectedCollectionIds = selectedCollections.map(c => c.id);
            const selectedCustomCollectionIds = selectedCustomCollections.map(c => c.id);

            const removeCollectionId = previousCollectionIds.filter(id => !selectedCollectionIds.includes(id));
            const removeCustomCollectionId = previousCustomCollectionIds.filter(id => !selectedCustomCollectionIds.includes(id));

            callData = {
                ...callData,
                collectionIds: [...new Set(selectedCollectionIds)],
                customCollectionId: [...new Set(selectedCustomCollectionIds)],
                removeCollectionId: [...new Set(removeCollectionId)],
                removeCustomCollectionId: [...new Set(removeCustomCollectionId)]
            };

            try {
                const response = await updateProduct(callData, params.productId);

                if (response?.status === 200) {
                    await cachedDataPublish([`/v1/product/${params.productId}`]);
                    setLoading(false);
                    showToast('Product Updated!', 'success');
                    dispatch(fetchInventoryProducts());
                    navigate(`${location.pathname.split('/').slice(0, -1).join('/')}`);
                } else {
                    setLoading(false);
                    showToast('Error updating product!', 'error');
                }
            } catch (err) {
                setLoading(false);
                showToast('Error updating product!', 'error');
            }
        } else {
            setFormErrors(validationErrors);
            return;
        }
    }

    useEffect(() => {
        if (params.productId) {
            dispatch(fetchInventoryProduct(params.productId));
        }
        // eslint-disable-next-line
    }, [params]);

    async function getSizeChartInfo(chartId) {
        try {
            const response = await getSizeChartById(chartId);
            if (response.status === 200) {
                setSelectedChart(response.data.data);
            }
        } catch (err) {
            // ignore
        }
    }

    useEffect(() => {
        if (Object.keys(activeProduct || {}).length === 0) return;

        const { product } = activeProduct || {};
        if (!product) return;

        const norm = (s) =>
            (s ?? '')
                .toString()
                .trim()
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, '');

        const isBeauty = norm(product.productCategory) === norm('Beauty & Personal Care');

        setSelectedCategory1(product.productCategory || '');
        setSelectedCategory2(product.productType || '');
        setSelectedCategory(product.productCategory || '');
        setSelectedProductType(product.productType || '');

        setProductDetails({
            productName: product.productName || '',
            productDescription: product.productDesc || ''
        });

        const theGSTCode = gstCodes.find(code => code.id === product.productTaxCode);
        let discount;
        if (
            typeof product.productSellingPrice === 'number' &&
            typeof product.productMRP === 'number' &&
            product.productSellingPrice < product.productMRP
        ) {
            discount = Math.round(100 - (product.productSellingPrice / product.productMRP) * 100);
        }

        setPricesAndTaxes({
            mrp: product.productMRP ?? 0,
            discount,
            sellingPrice: product.productSellingPrice ?? 0,
            hsnCode: product.productHSNCode || '',
            taxCode: theGSTCode || {},
            country: 'India'
        });

        setPackagingDetails({
            width: product.width ?? '',
            height: product.height ?? '',
            weight: product.weight ?? ''
        });

        const normType = norm(product.productType);
        const specDef =
            specificationsArray?.find((s) => {
                const id = norm(s?.id);
                const name = norm(s?.name);
                return (
                    (id && (id.includes(normType) || normType.includes(id))) ||
                    (name && (name.includes(normType) || normType.includes(name)))
                );
            }) || null;

        const shouldSkipKey = (key) => {
            const k = norm(key);
            if (k === 'color' || k === 'size') return true;
            if (isBeauty && k === 'volume') return true;
            return false;
        };

        let result =
            specDef?.list
                ?.map((option) => ({
                    labelText: option,
                    id: toCamelCase(option),
                    value: ''
                }))
                ?.filter((f) => !shouldSkipKey(f.id)) ??
            Object.keys(product?.productSpecs ?? {})
                .filter((k) => !shouldSkipKey(k))
                .map((k) => ({
                    labelText: camelCaseToReadable(k),
                    id: k,
                    value: ''
                }));

        const primarySpecs = {
            color: String(product?.productSpecs?.color ?? ''),
            size: String(product?.productSpecs?.size ?? '')
        };

        const addnSpecs = [];
        const specsObj = product?.productSpecs ?? {};

        for (const key in specsObj) {
            const val = String(specsObj[key] ?? '');
            if (shouldSkipKey(key)) continue;

            const item = result.find((r) => norm(r.id) === norm(key));
            if (item) {
                item.value = val;
            } else {
                addnSpecs.push({
                    labelText: camelCaseToReadable(key),
                    id: key,
                    value: val
                });
            }
        }

        setSpecifications(primarySpecs);
        setProductSpecifications(result);
        setAdditionalSpecifications(addnSpecs);

        if (product.keywords && Array.isArray(product.keywords)) {
            setKeywords(product.keywords.map((kw) => ({ keyword: kw, id: uuidv4() })));
        } else {
            setKeywords([]);
        }

        if (product?.Tag) {
            setSelectedTags(product.Tag);
        } else {
            setSelectedTags([]);
        }

        if (product.productImgUrls && Array.isArray(product.productImgUrls)) {
            setProductImages(
                product.productImgUrls.map((img) => ({
                    id: uuidv4(),
                    url: img,
                    file: null
                }))
            );
        } else {
            setProductImages([]);
        }

        setInventoryInputs({
            skuCode: product.productSKU ? product.productSKU : '',
            stock: product.productStock ? product.productStock : 0
        });

        if (product.SizeChartId) {
            getSizeChartInfo(product.SizeChartId);
        }
        // eslint-disable-next-line
    }, [activeProduct]);

    return (
        <div className="w-full overflow-y-scroll pb-16 no-scrollbar">
            <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-full flex items-start">
                    <Link to={`${location.pathname.split('/').slice(0, -1).join('/')}`} className="img p-[10px] flex items-center justify-center">
                        <img className='size-6 text-[#666666]' src={ArrowLeft} alt="" />
                    </Link>

                    <h1 className="w-[calc(100%-24px)] p-[6px] text-[#121212] font-bold leading-8 text-[24px] ">Edit Product &#40;{activeProduct.product?.productName}&#41;</h1>
                </div>
            </div>

            <div className="mt-6 mx-5 flex gap-4">
                <div className="w-[65%] flex flex-col gap-4">
                    <ProductDetails />

                    <AddProductImage
                        errorText={formErrors.images}
                    />

                    <PricesAndTaxes />

                    <Specification
                        selectedCategory1={selectedCategory1}
                        selectedCategory2={selectedCategory2}
                    />

                    <PackagingDetails />

                    <div className="flex flex-col gap-6 border border-[#EAEAEA] p-5 rounded-xl">
                        <div className="flex items-center justify-between">
                            <label className='w-fit select-none cursor-pointer font-semibold text-[18px] leading-6 text-[#121212]' htmlFor="keywords">Keywords<span className="text-[#DC2626]">*</span></label>

                            {
                                formErrors.keywords &&
                                <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.keywords}</p>
                            }
                        </div>

                        <div className="h-32 px-3 py-4 bg-[#F5F5F5] border border-[#EAEAEA] rounded-[9px] flex gap-2 flex-wrap focus-within:border-primaryColor">
                            {
                                keywords?.map(keyword => {
                                    return (
                                        <div key={keyword.id} className="w-fit h-fit border border-[#EAEAEA] bg-[#FFFFFF] rounded px-2 py-1 flex items-center">
                                            <p className='font-normal text-[14px] leading-6 text-[#121212]'>{keyword.keyword}</p>

                                            <button onClick={() => removeKeyword(keyword.id)} className="w-4 h-4 p-[3px] flex items-center justify-center">
                                                <img src={CrossSmall} alt="" />
                                            </button>
                                        </div>
                                    );
                                })
                            }

                            {
                                keywords?.length < 5 &&
                                <input
                                    className='py-1 flex-grow h-fit font-normal outline-none text-base bg-transparent text-[#121212] placeholder:text-[#888888]'
                                    placeholder='Enter keyword and hit enter (Max 5 keywords)'
                                    type="text"
                                    id='keyword'
                                    value={keywordValue}
                                    onChange={handleChange}
                                    onKeyDown={handleKeyDown}
                                />
                            }
                        </div>
                    </div>

                    <div className="flex gap-3 mt-2 ml-auto">
                        {
                            !['Active', 'Inactive', 'InActive'].includes(activeProduct?.product?.status) &&
                            <button onClick={handleSaveDraft} className='outline-none px-5 py-[10px] bg-[#FFFFFF] rounded font-semibold text-base text-[#808080]'>Save as draft</button>
                        }

                        <button onClick={handleUpdateClick} className='outline-none px-5 py-[10px] bg-primaryColor hover:bg-primaryAccent rounded font-semibold text-base text-buttonText'>Update</button>
                    </div>
                </div>

                <div className="w-[35%] flex flex-col gap-4">
                    <ProductOrganisation />

                    <SelectCategory />

                    <Tags />

                    <SizeChart />
                </div>
            </div>

            <Modal />

            {
                loading &&
                <LoadingTransparent 
                    message='Updating product...'
                />
            }
        </div>
    );
}

export default InventoryEditProduct;
